import {
  Card,
  Col,
  ConfigProvider,
  Divider,
  message,
  Modal,
  Progress,
  Row,
  Table,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import Descriptions from "../../../components/Description/Descriptions";
import color from "../../../resource/color";
import { numberFormatter } from "../../../utility/Formatter";
import {
  getArBalanceDetail,
  getDetail,
  getInvoiceTemporary,
  syncCreditLimit,
} from "../../../datasource/OrderCreditDatasource";
import PageSpin from "../../../components/Spin/pageSpin";
import Button from "../../../components/Button/Button";
import icon from "../../../resource/icon";
import { creditLimitDetailState } from "../../../store/CreditLimitDetail";
import { useRecoilState } from "recoil";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FlexCol } from "../../../components/Container/Container";
import dayjs from "dayjs";

export const BoxContainer = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return <Card style={{ backgroundColor: "#FAFAFA", ...style }}>{children}</Card>;
};

export const MainOrderCreditDetailTabNew = ({
  sync = false,
  isOverCredit = false,
  cusComId,
}: {
  sync?: boolean;
  isOverCredit?: boolean;
  cusComId?: string | undefined;
}) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const [syncing, setSyncing] = useState(false);
  const [recoilState, setRecoilState] = useRecoilState(creditLimitDetailState);
  const [modalInvTemp, setModalInvTemp] = useState<{
    open: boolean;
    cusComName?: string;
    cusComId?: string;
  }>({
    open: false,
    cusComName: undefined,
    cusComId: undefined,
  });
  const [arBalanceDetail, setArBalanceDetail] = useState<any>(null);

  useEffect(() => {
    fetchData(cusComId);
  }, [cusComId]);

  const fetchData = async (cusComId?: string) => {
    setLoading(true);
    const detail = await getDetail(cusComId || id);
    if (detail.customerNo) setRecoilState({ ...recoilState, customerNo: detail.customerNo });
    console.log("detail", detail);
    setData(detail);

    const arBalanceDetail = await getArBalanceDetail(cusComId || id);
    setArBalanceDetail(arBalanceDetail);
    setLoading(false);
  };

  const syncData = async () => {
    setSyncing(true);
    await syncCreditLimit({
      company,
      customerNo: recoilState.customerNo || data?.customerNo,
    })
      .then((res) => {
        if (res?.success) {
          message.success("อัปเดตข้อมูลแล้ว");
          fetchData();
        } else {
          message.error("เกิดข้อผิดพลาด");
        }
      })
      .finally(() => {
        setSyncing(false);
      });
  };

  const details = [
    {
      label: "รหัสร้านค้า",
      value: data?.customerNo,
    },
    {
      label: "ชื่อร้านค้า",
      value: data?.customerName,
    },
    {
      label: "เลขนิติบุคคล",
      value: data?.taxNo,
    },
    {
      label: "ชื่อเจ้าของร้าน",
      value: data?.ownerFirstname ? data?.ownerFirstname + " " + data?.ownerLastname : null,
    },
    {
      label: "เบอร์โทร ",
      value: data?.telephone,
    },
    {
      label: "เขต",
      value: data?.zone,
    },
  ];

  const detailPending =
    company !== "ICPL"
      ? [
          {
            label: "ยืนยันการสั่งซื้อแล้ว",
            value: data.approveOrder || 0,
          },
          {
            label: "รอรถเข้ารับสินค้า",
            value: data.pendingOpenOrder || 0,
          },
          {
            label: "อยู่ระหว่างขึ้นสินค้า",
            value: data.pendingInDelivery || 0,
          },
          {
            label: "ขึ้นสินค้าเรียบร้อย",
            value: data.deliverySuccess || 0,
          },
        ]
      : [
          {
            label: "ยืนยันการสั่งซื้อแล้ว",
            value: data.approveOrder || 0,
          },
          {
            label: "กำลังดำเนินการ",
            value: data.soPending || 0,
          },
        ];

  return loading ? (
    <PageSpin />
  ) : (
    <>
      <Row justify='space-between'>
        <Col span={8}>
          <Text fontWeight={700}>ข้อมูลร้านค้า</Text>
        </Col>
        <Col span={4}>
          {sync && (
            <Button
              title='อัปเดตข้อมูลใหม่'
              typeButton='border-primary'
              icon={<img src={icon.reload} style={{ width: 15, height: 17, marginBottom: 4 }} />}
              onClick={() => syncData()}
              loading={syncing}
            />
          )}
        </Col>
      </Row>
      <br />
      {details.map(({ label, value }, i) => (
        <>
          <Descriptions
            label={label}
            value={value || "-"}
            leftSpan={5}
            style={{ padding: "6px 0px" }}
            noColon
          />
        </>
      ))}
      <br />
      <Text level={5} fontWeight={600}>
        วงเงินร้านค้า
      </Text>
      <Row justify='space-between' gutter={8}>
        <Col span={12}>
          <BoxContainer>
            <Row>
              <Col>
                <Text fontWeight={600}>วงเงินหลัก</Text>
                <br />
                <Text>(Primary Credit Limit)</Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text fontWeight={600} level={4}>
                  {numberFormatter(data.creditLimit, 2)}&nbsp;
                </Text>
              </Col>
            </Row>
            <Row>
              <Progress
                strokeColor={color.primary}
                percent={data.primaryBalancePercentApp}
                showInfo={false}
              />
            </Row>
            <Row justify='space-between'>
              <Col>
                <Text level={6}>
                  คงเหลือ{" "}
                  <b style={{ color: data.primaryBalanceApp < 0 ? "red" : "black" }}>
                    {numberFormatter(data.primaryBalanceApp, 2)} ฿
                  </b>
                </Text>
                &nbsp;
                <Text level={6} color={data.creditLimitUsedPercentApp < 0 ? "error" : "Text3"}>
                  ({numberFormatter(data.creditLimitUsedPercentApp, 2)}%)
                </Text>
              </Col>
              <Col>
                <Text level={6}>ใช้ไป {numberFormatter(data.creditLimitUsedApp, 2)} ฿</Text>
              </Col>
            </Row>
          </BoxContainer>
        </Col>
        <Col span={12}>
          <BoxContainer>
            <Row justify='space-between'>
              <Col>
                <Text fontWeight={600}>วงเงินชั่วคราว</Text>
                <br />
                <Text>(Temporary Credit Limit)</Text>
              </Col>
              <Col>
                <Text level={6}>{data.orderOverCredit || 0} คำขอ</Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text fontWeight={600} level={4}>
                  {numberFormatter(data.overCredit || 0, 2)}&nbsp;
                </Text>
              </Col>
            </Row>
            <Row>
              <Progress
                strokeColor={color.warning}
                percent={data.overCreditBalancePercentApp}
                showInfo={false}
              />
            </Row>
            <Row justify='space-between'>
              <Col>
                <Text level={6}>
                  คงเหลือ{" "}
                  <b style={{ color: data.overCreditBalanceApp < 0 ? "red" : "black" }}>
                    {numberFormatter(data.overCreditBalanceApp || 0, 2)} ฿
                  </b>
                </Text>
                &nbsp;
                <Text level={6} color='Text3'>
                  ({numberFormatter(data.overCreditBalancePercentApp || 0, 2)}%)
                </Text>
              </Col>
              <Col>
                <Text level={6}>ใช้ไป {numberFormatter(data.overCreditUsedApp || 0, 2)} ฿</Text>
              </Col>
            </Row>
          </BoxContainer>
        </Col>
      </Row>
      <br />
      <Row justify='space-between' gutter={8}>
        <Col span={24}>
          <BoxContainer>
            <Row>
              <Text>วงเงินรวมทั้งหมด (Total Credit Limit)</Text>&nbsp;
              <Text fontWeight={600}>{numberFormatter(data.creditLimitTotal || 0, 2)}</Text>
            </Row>
            <Card style={{ borderColor: "#FFFFFF" }} bodyStyle={{ padding: "12px" }}>
              <Text fontWeight={600}>วงเงินคงเหลือทั้งหมด</Text>
              <br />
              <Text level={6}>(Credit Limit Balance)</Text>
              <Row justify='space-between'>
                <Col>
                  <Text
                    fontWeight={600}
                    level={3}
                    color={data.creditLimitBalance < 0 ? "error" : "BK"}
                  >
                    {numberFormatter(data.creditLimitBalance || 0, 2)} ฿
                  </Text>
                  &nbsp;
                  <Text level={6} color={data.percentCreditBalance < 0 ? "error" : "Text3"}>
                    ({numberFormatter(data.percentCreditBalance || 0, 2)} %)
                  </Text>
                </Col>
                <Col>
                  <Text>ใช้ไป {numberFormatter(data.creditLimitTotalUsedDetail || 0, 2)} ฿</Text>
                </Col>
              </Row>
            </Card>
            <br />
            {data.limitCreditPercent > 0 && (
              <Card style={{ borderColor: "#FFFFFF" }} bodyStyle={{ padding: "12px" }}>
                <Row justify='space-between'>
                  <Col>
                    <Text fontWeight={600} level={4}>
                      เพดานวงเงินเกิน
                    </Text>
                    <br />
                    <Text level={6}>(Max Over-Limit)</Text>
                  </Col>
                  <Col style={{ textAlign: "right" }}>
                    <Text fontWeight={600} level={4}>
                      {numberFormatter(data.calLimitCredit || 0, 2)} ฿
                    </Text>
                    <br />
                    <Text level={6} color='Text3'>
                      ({data.limitCreditPercent}% ของวงเงินหลัก)
                    </Text>
                  </Col>
                </Row>
                <Row justify='space-between'>
                  <Progress
                    strokeColor={{
                      "0%": "#ECC500",
                      "100%": "#C29B00",
                    }}
                    trailColor='#EDF1F5'
                    percent={data.usedLimitCreditPercent}
                    showInfo={false}
                  />
                </Row>
                <Row justify='space-between'>
                  <Col>
                    <Text level={6}>
                      ใช้ไป <b>{numberFormatter(data.usedLimitCredit || 0, 2)} ฿</b> (
                      {numberFormatter(data.usedLimitCreditPercent || 0, 2)}% ของเพดาน)
                    </Text>
                  </Col>

                  <Col>
                    {data.usedLimitCreditPercent > 80 && data.usedLimitCreditPercent <= 100 && (
                      <Tag style={{ borderRadius: "20px", borderColor: color.warning }}>
                        <Text fontSize={12} fontWeight={600} color='warning'>
                          {data.usedLimitCreditPercent > 80 && data.usedLimitCreditPercent !== 100
                            ? "ใกล้เพดานแล้ว"
                            : "เต็มเพดาน"}
                        </Text>
                      </Tag>
                    )}
                    {data.usedLimitCreditPercent > 100 && (
                      <Tag style={{ borderRadius: "20px", borderColor: color.error }}>
                        <Text fontSize={12} fontWeight={600} color='error'>
                          เกินเพดาน
                        </Text>
                      </Tag>
                    )}
                  </Col>
                </Row>
              </Card>
            )}
          </BoxContainer>
        </Col>
      </Row>
      <br />
      <Text level={5} fontWeight={600}>
        รายละเอียด
      </Text>
      <Row justify='space-between' gutter={8}>
        <Col span={12}>
          <BoxContainer style={{ height: "310px" }}>
            <Row justify='space-between'>
              <Col>
                <Text fontWeight={600}>ลูกหนี้การค้า</Text>
                <br />
                <Text>(AR Balance)</Text>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Text level={3} fontWeight={600} color={data.arBalance != 0 ? "error" : "BK"}>
                  {numberFormatter(data.arBalance || 0, 2)} ฿
                </Text>
                <br />
                <Text color={data.arBalance != 0 ? "error" : "BK"}>
                  ({numberFormatter(data.arBalancePercent || 0, 2)}%)
                </Text>
              </Col>
            </Row>
            <Divider size='small' />
            <Row justify='space-between'>
              <Col>
                <Text>ครบกำหนดชำระแล้ว</Text>
              </Col>
              <Col>
                <Text fontWeight={600} color={data.arOverdue > 0 ? "error" : "BK"}>
                  {numberFormatter(data.arOverdue || 0, 2)} ฿
                </Text>
              </Col>
            </Row>
            <Row justify='space-between'>
              <Col>
                <Text>ยังไม่ถึงกำหนด</Text>
              </Col>
              <Col>
                <Text fontWeight={600}>{numberFormatter(data.arNotOverdue || 0, 2)} ฿</Text>
              </Col>
            </Row>
            <Divider size='small' />
            <Text fontWeight={600}>วงเงินที่ใช้</Text>
            <Card
              style={{ borderColor: "#EFF2F9", backgroundColor: "#EFF2F9" }}
              bodyStyle={{ padding: "12px" }}
            >
              <Row justify='space-between'>
                <Col>
                  <Text>วงเงินหลัก</Text>
                </Col>
                <Col>
                  <Text>{numberFormatter(arBalanceDetail?.arBalancePrimaryCredit || 0, 2)} ฿</Text>
                </Col>
              </Row>{" "}
              <Row justify='space-between'>
                <Col>
                  <Text>วงเงินชั่วคราว</Text>{" "}
                  {arBalanceDetail?.arBalanceTemporaryCredit > 0 && (
                    <ExclamationCircleOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setModalInvTemp({ open: true, cusComId: id, cusComName: data.customerName })
                      }
                    />
                  )}
                </Col>
                <Col>
                  <Text>
                    {numberFormatter(arBalanceDetail?.arBalanceTemporaryCredit || 0, 2)} ฿
                  </Text>
                </Col>
              </Row>
              <Row justify='space-between'>
                <Col>
                  <Text>วงเงินเกิน</Text>
                </Col>
                <Col>
                  <Text color={arBalanceDetail?.arBalanceOverCredit !== 0 ? "error" : "BK"}>
                    {numberFormatter(arBalanceDetail?.arBalanceOverCredit || 0, 2)} ฿
                  </Text>
                </Col>
              </Row>
            </Card>
          </BoxContainer>
        </Col>
        <Col span={12} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <BoxContainer style={{ height: "150px" }}>
            <Row justify='space-between'>
              <Col>
                <Text fontWeight={600}>ยอดหนี้ค้างชำระ</Text>
                <br />
                <Text>(Outstanding)</Text>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Text
                  fontWeight={600}
                  level={3}
                  color={(data.outstanding || 0) !== 0 ? "error" : "BK"}
                >
                  {numberFormatter(data.outstanding || 0, 2)} ฿
                </Text>
                <br />
                <Text color={(data.outstanding || 0) !== 0 ? "error" : "BK"}>
                  ({numberFormatter(data.outstandingPercent || 0, 2)}%)
                </Text>
              </Col>
            </Row>
          </BoxContainer>
          <BoxContainer style={{ height: "150px" }}>
            <Row justify='space-between'>
              <Col>
                <Text fontWeight={600}>เช็คลงวันที่ล่วงหน้า</Text>
                <br />
                <Text>(PDC)</Text>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Text fontWeight={600} level={3} color={data.pdcCollect > 0 ? "success" : "BK"}>
                  {numberFormatter(data.pdcCollect || 0, 2)} ฿
                </Text>
                <br />
                <Text color={data.pdcCollect > 0 ? "success" : "BK"}>
                  ({numberFormatter(data.pdcCollectPercent || 0, 2)}%)
                </Text>
              </Col>
            </Row>
          </BoxContainer>
        </Col>
      </Row>
      <br />
      <BoxContainer>
        <Row justify='space-between'>
          <Col>
            <Text fontWeight={600}>คำสั่งซื้อที่กำลังดำเนินการ</Text>
            <br />
            <Text>(Order Pending)</Text>
          </Col>
          <Col style={{ textAlign: "right" }}>
            <Text fontWeight={600} level={3}>
              {numberFormatter(data.pending || 0, 2)} ฿
            </Text>
            <br />
            <Text>({numberFormatter(data.pendingPercent || 0, 2)}%)</Text>
          </Col>
        </Row>
        <Divider size='small' />
        {detailPending.map(({ label, value }, i) => (
          <Row justify='space-between' style={{ marginBottom: 4 }} key={i}>
            <Col>
              <Text>{label}</Text>
            </Col>
            <Col>
              <Text>{numberFormatter(value || 0, 2)} ฿</Text>
            </Col>
          </Row>
        ))}
      </BoxContainer>
      {modalInvTemp.open && (
        <ModalInvoiceTemporaryCredit
          open={modalInvTemp.open}
          customerCompanyId={modalInvTemp.cusComId || ""}
          company={company}
          customerName={modalInvTemp.cusComName}
          onCancel={() =>
            setModalInvTemp({ open: false, cusComId: undefined, cusComName: undefined })
          }
        />
      )}
    </>
  );
};

export const ModalInvoiceTemporaryCredit = ({
  customerCompanyId,
  company,
  open,
  onCancel,
  customerName,
}: {
  customerCompanyId: string;
  company: string;
  open: boolean;
  onCancel: () => void;
  customerName?: string;
}) => {
  const [data, setData] = useState<any>(null);
  const fetchData = async () => {
    const res = await getInvoiceTemporary({ customerCompanyId, company });
    setData(res);
  };

  useEffect(() => {
    fetchData();
  }, [customerCompanyId]);

  const columns = [
    {
      title: "วันที่ออกเอกสาร",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value: string, row: any) => {
        return (
          <FlexCol>
            <Text>{dayjs(value).format("DD/MM/YYYY")}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "รหัสใบแจ้งหนี้",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
      render: (value: string, row: any) => {
        return (
          <FlexCol>
            <Text>{value}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "ยอดรวมทั้งหมด (฿)",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (value: string, row: any) => {
        return (
          <FlexCol style={{ textAlign: "right" }}>
            <Text>{numberFormatter(value)}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "ตัดวงเงินหลัก (฿)",
      dataIndex: "primaryCreditAmount",
      key: "primaryCreditAmount",
      render: (value: string, row: any) => {
        return (
          <FlexCol style={{ textAlign: "right" }}>
            <Text>{numberFormatter(value)}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "ตัดวงเงินชั่วคราว (฿)",
      dataIndex: "tempCreditAmount",
      key: "tempCreditAmount",
      render: (value: string, row: any) => {
        return (
          <FlexCol style={{ textAlign: "right" }}>
            <Text>{numberFormatter(value)}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "รหัสคำขอวงเงินชั่วคราว",
      dataIndex: "temporaryCreditLimitCode",
      key: "temporaryCreditLimitCode",
      render: (value: string, row: any) => {
        return (
          <FlexCol>
            <Text>{value}</Text>
          </FlexCol>
        );
      },
    },
  ];

  return (
    <Modal
      maskClosable={false}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={1100}
      title={
        <>
          <Text fontWeight={600} level={4}>
            วงเงินชั่วคราวที่ใช้
          </Text>
          <br />
          <Text level={5}>{customerName}</Text>
        </>
      }
      centered
    >
      <Row justify='end' style={{ marginBottom: 8 }}>
        <Text>{data?.count || 0} รายการ</Text>
      </Row>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
            },
          },
        }}
      >
        <Table
          size='small'
          columns={columns}
          dataSource={data?.data || []}
          pagination={false}
          scroll={{ x: "max-content", y: 400 }}
        />
      </ConfigProvider>
    </Modal>
  );
};
